import { render, staticRenderFns } from "./ModelPage.vue?vue&type=template&id=1ffaafea&scoped=true"
import script from "./ModelPage.vue?vue&type=script&lang=js"
export * from "./ModelPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffaafea",
  null
  
)

export default component.exports